import $ from 'jquery'

export default () => {
    function init() {
        window.VideoMediaParser = (function() {
            'use strict';

            var videos;

            function VideoMediaParser() {
                videos = document.querySelectorAll('video');
                window.addEventListener('resize', handleVideos);
                handleVideos();
            }

            function handleVideos() {
                for (var i = 0; i < videos.length; ++i)
                    handleVideo(videos[i]);
            }

            function handleVideo(video) {
                var sources = video.getElementsByTagName('source');

                if(!sources)
                    return;

                var new_source = getBestSource(sources);

                if(new_source.src != video.src)
                    video.src = new_source.src;
                if(new_source.hasAttribute('muted'))
                    video.muted = true;
            }

            function getBestSource(sources) {
                for (var i = 0; i < sources.length; ++i) {
                    var source = sources[i];
                    var media = source.getAttribute('media');

                    if(!media)
                        return source;

                    var media_query = window.matchMedia(media);

                    if(media_query.matches)
                        return source;
                }
            }

            return VideoMediaParser;
        })();

        VideoMediaParser();
    }

    return Object.freeze({
        init
    })
}